import { minimumRises } from 'constants/index'

export const getMinimumRise = amount =>
  minimumRises.find(({ range: [min, max] }) => min <= amount && (!max || max > amount))?.rise || 0
